module.exports = __webpack_public_path__ + "img/56.3e5157be.jpg";